import {
  getEventCategoryList,
  postEventCategory,
  updateEventCategory,
  deleteEventCategory,
} from "@/services/event-category.service";

// initial state
const state = () => ({
  eventCategoryModel: {},
});

// mutations
const mutations = {
  setEventCategoryModel(state, data) {
    state.eventCategoryModel = data;
  },
};

// actions
const actions = {
  //Etkinlik Listesi
  async loadEventCategoryList(vuexContext, co) {
    return await getEventCategoryList(co).then((response) => {
      let data = response.data.data.items;

      data.map((item, index) => {
        item.index = index + 1;
        item.label = item.name;
        item.value = item.id;
      });
      return data;
    });
  },

  async postEventCategory(vuexContext, data) {
    return await postEventCategory(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async updateEventCategory(vuexContext, data) {
    return await updateEventCategory(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async deleteEventCategory(vuexContext, eventCategoryId) {
    return await deleteEventCategory(eventCategoryId).then((response) => {
      let data = response;
      return data;
    });
  },

  addEventCategoryModel(vuexContext, data) {
    vuexContext.commit("setEventCategoryModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
